<div class="container">
  <iframe *ngIf="helpUrl" [src]="helpUrl" frameborder="0"></iframe>
</div>
